import { useEffect, useState } from "react";

// Governs which color theme is active (classic/warm/...), independently of
// light/dark (useDarkMode.js). Defaults to "classic" - the design you
// already know - so switching is always an opt-in choice, never a surprise.
export const useDesignMode = () => {
  const [design, setDesignState] = useState("classic");
  const [mountedComponent, setMountedComponent] = useState(false);

  const setDesign = mode => {
    window.localStorage.setItem("design", mode);
    setDesignState(mode);
  };

  useEffect(() => {
    const localDesign = window.localStorage.getItem("design");
    localDesign && setDesignState(localDesign);
    setMountedComponent(true);
  }, []);

  return [design, setDesign, mountedComponent];
};
